// import config from '../../config';

export const isTraktezEnvironment = false;

// export const isTraktezEnvironment =
//   config.COOKIE_DOMAIN && config.COOKIE_DOMAIN === '.traktez.com';
